export default "__VITE_ASSET__R$px6yda__"